import React, { StrictMode } from 'react'
import { render } from 'react-dom'

import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'

import reducer from './reducers'
import App from './App'
import './index.css' // postCSS import of CSS module

import { AuthProvider } from 'react-oidc-context'

const COGNITO_AUTHORITY = process.env.REACT_APP_COGNITO_AUTHORITY
const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID
// const COGNITO_REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI
// const COGNITO_RESPONSE_TYPE = process.env.REACT_APP_COGNITO_RESPONSE_TYPE
// const COGNITO_SCOPE = process.env.REACT_APP_COGNITO_SCOPE

// FIXME: get these from environment variables
const cognitoAuthConfig = {
  authority: COGNITO_AUTHORITY,
  client_id: COGNITO_CLIENT_ID,
  redirect_uri: window.location.origin + '/', // "https://app-dev.drivepoints.com/",
  response_type: 'code',
  scope: 'email openid profile',
}

const middleware = [thunk]

const appRootElement =
  document.getElementById('valhalla-app-root') ||
  document.getElementById('root')

if (!appRootElement) {
  throw new Error(
    'App root element not found (expected #valhalla-app-root or #root)'
  )
}

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
)

if (!COGNITO_AUTHORITY || !COGNITO_CLIENT_ID) {
  alert(
    'COGNITO_AUTHORITY and COGNITO_CLIENT_ID must be set as an environment variable'
  )
  render(
    <>Error: COGNITO_AUTHORITY and COGNITO_CLIENT_ID must be set</>,
    appRootElement
  )
  throw new Error('COGNITO_AUTHORITY and COGNITO_CLIENT_ID must be set')
}

render(
  <StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <Provider store={store}>
        {' '}
        <App />
      </Provider>
    </AuthProvider>
  </StrictMode>,
  appRootElement
)
